/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable func-names */
/* eslint-disable no-loop-func */
/* eslint-disable global-require */

import * as d3 from 'd3';
import { parseSvg } from 'd3-interpolate/src/transform/parse';

export function arrangeLabels(svg) {
  let move = 1;
  while (move > 0) {
    move = 0;
    svg.selectAll('.map-label')
      .each(function () {
        const that = this;
        let a = this.getBoundingClientRect();
        svg.selectAll('.map-label')
          .each(function () {
            if (this !== that) {
              const b = this.getBoundingClientRect();
              if ((Math.abs(a.left - b.left) * 2 < (a.width + b.width))
                && (Math.abs(a.top - b.top) * 2 < (a.height + b.height))) {
                // overlap, move labels
                const dx = (Math.max(0, a.right - b.left)
                  + Math.min(0, a.left - b.right)) * 0.01;
                const dy = (Math.max(0, a.bottom - b.top)
                  + Math.min(0, a.top - b.bottom)) * 0.02;
                const tt = parseSvg(d3.select(this).attr('transform'));
                const to = parseSvg(d3.select(that).attr('transform'));
                // console.log(tt);
                move += Math.abs(dx) + Math.abs(dy);

                to.translate = [to.translateX + dx, to.translateY + dy];
                tt.translate = [tt.translateX - dx, tt.translateY - dy];
                d3.select(this).attr('transform', `translate(${tt.translate})`);
                d3.select(that).attr('transform', `translate(${to.translate})`);
                a = this.getBoundingClientRect();
              }
            }
          });
      });
  }
}

export const US = require('@amcharts/amcharts4-geodata/usaHigh').default;

export default US;
const AK = require('@amcharts/amcharts4-geodata/region/usa/akHigh').default;
const AL = require('@amcharts/amcharts4-geodata/region/usa/alHigh').default;
const AR = require('@amcharts/amcharts4-geodata/region/usa/arHigh').default;
const AZ = require('@amcharts/amcharts4-geodata/region/usa/azHigh').default;
const CA = require('@amcharts/amcharts4-geodata/region/usa/caHigh').default;
const CO = require('@amcharts/amcharts4-geodata/region/usa/coHigh').default;
const CT = require('@amcharts/amcharts4-geodata/region/usa/ctHigh').default;
const DC = require('@amcharts/amcharts4-geodata/region/usa/dcHigh').default;
const DE = require('@amcharts/amcharts4-geodata/region/usa/deHigh').default;
const FL = require('@amcharts/amcharts4-geodata/region/usa/flHigh').default;
const GA = require('@amcharts/amcharts4-geodata/region/usa/gaHigh').default;
const HI = require('@amcharts/amcharts4-geodata/region/usa/hiHigh').default;
const IA = require('@amcharts/amcharts4-geodata/region/usa/iaHigh').default;
const ID = require('@amcharts/amcharts4-geodata/region/usa/idHigh').default;
const IL = require('@amcharts/amcharts4-geodata/region/usa/ilHigh').default;
const IN = require('@amcharts/amcharts4-geodata/region/usa/inHigh').default;
const KS = require('@amcharts/amcharts4-geodata/region/usa/ksHigh').default;
const KY = require('@amcharts/amcharts4-geodata/region/usa/kyHigh').default;
const LA = require('@amcharts/amcharts4-geodata/region/usa/laHigh').default;
const MA = require('@amcharts/amcharts4-geodata/region/usa/maHigh').default;
const MD = require('@amcharts/amcharts4-geodata/region/usa/mdHigh').default;
const ME = require('@amcharts/amcharts4-geodata/region/usa/meHigh').default;
const MI = require('@amcharts/amcharts4-geodata/region/usa/miHigh').default;
const MN = require('@amcharts/amcharts4-geodata/region/usa/mnHigh').default;
const MO = require('@amcharts/amcharts4-geodata/region/usa/moHigh').default;
const MS = require('@amcharts/amcharts4-geodata/region/usa/msHigh').default;
const MT = require('@amcharts/amcharts4-geodata/region/usa/mtHigh').default;
const NC = require('@amcharts/amcharts4-geodata/region/usa/ncHigh').default;
const ND = require('@amcharts/amcharts4-geodata/region/usa/ndHigh').default;
const NE = require('@amcharts/amcharts4-geodata/region/usa/neHigh').default;
const NH = require('@amcharts/amcharts4-geodata/region/usa/nhHigh').default;
const NJ = require('@amcharts/amcharts4-geodata/region/usa/njHigh').default;
const NM = require('@amcharts/amcharts4-geodata/region/usa/nmHigh').default;
const NV = require('@amcharts/amcharts4-geodata/region/usa/nvHigh').default;
const NY = require('@amcharts/amcharts4-geodata/region/usa/nyHigh').default;
const OH = require('@amcharts/amcharts4-geodata/region/usa/ohHigh').default;
const OK = require('@amcharts/amcharts4-geodata/region/usa/okHigh').default;
const OR = require('@amcharts/amcharts4-geodata/region/usa/orHigh').default;
const PA = require('@amcharts/amcharts4-geodata/region/usa/paHigh').default;
const RI = require('@amcharts/amcharts4-geodata/region/usa/riHigh').default;
const SC = require('@amcharts/amcharts4-geodata/region/usa/scHigh').default;
const SD = require('@amcharts/amcharts4-geodata/region/usa/sdHigh').default;
const TN = require('@amcharts/amcharts4-geodata/region/usa/tnHigh').default;
const TX = require('@amcharts/amcharts4-geodata/region/usa/txHigh').default;
const UT = require('@amcharts/amcharts4-geodata/region/usa/utHigh').default;
const VA = require('@amcharts/amcharts4-geodata/region/usa/vaHigh').default;
const VT = require('@amcharts/amcharts4-geodata/region/usa/vtHigh').default;
const WA = require('@amcharts/amcharts4-geodata/region/usa/waHigh').default;
const WI = require('@amcharts/amcharts4-geodata/region/usa/wiHigh').default;
const WV = require('@amcharts/amcharts4-geodata/region/usa/wvHigh').default;
const WY = require('@amcharts/amcharts4-geodata/region/usa/wyHigh').default;

/**
 * From: Michael Austrin <michael@mo.childcareaware.org>
Sent: Wednesday, September 2, 2020 10:19 AM
To: Kristina Haynie <Kristina.Haynie@usa.childcareaware.org>
Subject: RE: Updated CCDC Site Ready for Review

Hi Kristina,
I’m looking at the data and I notice that on the interactive maps, St. Louis City is mis-labeled as Saint Louis County.
The data may be accurate, but the title is incorrect.  At the same time, Saint Louis County is fine.
The only other thing that may need correcting is in Missouri, we use St. rather than Saint.
So, that would be for St. Louis County, St. Louis City, St. Francois, Ste. Genevieve.
If you can pass on those corrections, I’d appreciate it.

 */
function fixMO() {
  MO.features = MO.features.map((feature) => {
    if (feature.id === '29510') {
      feature.properties.TYPE = 'City';
    }
    feature.properties.name = feature.properties.name.replace('Saint ', 'St. ');
    feature.properties.name = feature.properties.name.replace('Sainte ', 'Ste. ');

    return feature;
  });
}

(() => {
  fixMO();
})();

export const stateMaps = {
  AK,
  AL,
  AR,
  AZ,
  CA,
  CO,
  CT,
  DC,
  DE,
  FL,
  GA,
  HI,
  IA,
  ID,
  IL,
  IN,
  KS,
  KY,
  LA,
  MA,
  MD,
  ME,
  MI,
  MN,
  MO,
  MS,
  MT,
  NC,
  ND,
  NE,
  NH,
  NJ,
  NM,
  NV,
  NY,
  OH,
  OK,
  OR,
  PA,
  RI,
  SC,
  SD,
  TN,
  TX,
  UT,
  VA,
  VT,
  WA,
  WI,
  WV,
  WY,
};
